module.exports = __webpack_public_path__ + "img/v2_empty.8fa04e8c.png";